<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>აქ. ახლა პირველად ქართულ ბაზარზე კომერციული უძრავი ქონების ლიზინგი</h1>
    <h6>დეკემბერი 2021</h6>
    <br />
    <p>
      კომუნიკაციის თითოეულ ეტაპზე აღვნიშნავთ, რომ ლიზინგი თავის არსით დაფინანსების ის გზაა, რომელიც ბიზნესსაქმიანობას
      ამარტივებს, აქტივის ფლობასთან დაკავშირებულ საკითხებს აგვარებს და გეხმარება მიაღწიო მთავარს - დამოუკიდებლობას, უფრო
      სწორად - ბიზნეს დამოუკიდებლობას. ზემოთ თქმულის სადემონსტრაციოდ ქართულ ბაზარზე ინოვაციური შეთავაზება დავნერგეთ და
      მიუხედავად იმისა, რომ მსოფლიოში თითქმის ვერცერთ ქვეყანას სალიზინგო პროდუქტით ვეღარ გააკვირვებ, გადავწყვიტეთ
      შეგვექმნა ისეთი უნიკალური პროდუქტი, რომლის ანალოგიც ფაქტობრივად არ არსებობს.
    </p>

    <p>
      კომერციული უძრავი ქონების ლიზინგის უპირატესობებით სარგებლობა შეუძლიათ როგორც ფიზიკურ, ასევე იურიდიულ პირებს. ორივე
      შემთხვევაში მთავარი მიზანი ბიზნეს რესურსის სწორად გადანაწილებაა.
    </p>

    <img src="../../../../assets/blog/estate-leasing/img1.jpg" alt="" />

    <p>
      <i class="subhead capital light-blue"><b>ფიზიკური და იურიდიული პირებისთვის</b></i>
    </p>

    <p>
      თუ საკუთარი ბიზნესის განვითარების არცერთ ეტაპზე არ გსურს რესურსი ჰაერში, სრულიად ფუჭად გაფანტო და იჯარა იხადო, ეს
      შეთავაზება - შენთვისაა. ლიზინგის შემთხვევაში ყოველთვიური გადასახადი საიჯარო ხელშეკრულებით განსაზღვრული შენატანის
      კონკურენტუნარიანი ოდენობისაა, თუმცა ჩვენ გაძლევთ ქონების ფლობის გარანტიას. სალიზინგო ხელშეკრულების დასრულების
      შემდეგ კომერციული ფართი შენს საკუთრებაში გადმოდის და ბიზნესის განვითარება ახლა უკვე საკუთარ კედლებში შეგიძლია
      განაგრძო.
    </p>

    <p>
      <i class="subhead capital blue"><b>დეველოპერებისთვის</b></i>
    </p>

    <p>
      დეველოპერული კომპანიების წარმომადგენლებს ეძლევათ უნიკალური შესაძლებლობა კომპანიის საკუთრებაში არსებული აქტივით
      მიიღონ დაფინანსება მის რეალიზაციამდე. ასევე, შესაძლებელია გაქირავებული ფართების რეალიზაცია ლიზინგის დახმარებით
      საიჯარო თანხაზე მორგებული შენატანით.
    </p>

    <img src="../../../../assets/blog/estate-leasing/img2.jpg" alt="" />

    <p>
      <i class="subhead capital dark-blue"><b>ჩვენ ვაფინანსებთ:</b></i>
    </p>

    <p class="list-item">კომერციული, საწარმოო და საოფისე ფართის შესყიდვას;</p>
    <p class="list-item">დასრულებულ მშენებლობებში არასაცხოვრებელ და დამხმარე ფართებს, ასევე ავტოსადგომებს;</p>
    <p class="list-item">
      როგორც ფიზიკური, ისე იურიდიული პირის საკუთრებაში არსებული კომერციული ფართების უკულიზინგს, ანუ შესაძლებელია
      საკუთრებაში არსებული უძრავი ქონების საშუალებით ფულადი რესურსის მოპოვება;
    </p>

    <p>
      <i class="subhead capital dark-blue"><b>რატომ?</b></i>
    </p>

    <p class="list-item">ფართის რეალიზაციაზე მორგებული გადახდის გრაფიკი</p>
    <p class="list-item">მოქნილი და სწრაფი მომსახურება</p>
    <p class="list-item">ლიზინგის ვადა განსაზღვრულია 120 თვემდე</p>
    <p class="list-item">ჩვენთან გაცემის საკომიციო 0%-ია</p>
    <p class="list-item">ფინანსდება შეფასების მაქსიმუმ 80%დაფარვის გრაფიკი შენზე მორგებული,</p>
    <p class="list-item">ანუიტეტი ან არასტანდარტული.</p>

    <img src="../../../../assets/blog/estate-leasing/img3.jpg" alt="" />

    <p>
      თუ სესხს ანუიტეტით იხდი და ყოველთვიური შენატანის შემცირება გსურს, ლიზინგით რეფინანსირება საუკეთესო არჩევანია. ჩვენ
      ძირის ნაწილის, ლიზინგის ვადის ბოლოს გადახდას გთავაზობთ.
    </p>
    <p>
      აქვე, რამდენიმე პრაქტიკული მაგალითით მოგიყვებით, როგორ შეგიძლია ისარგებლო ახალი პროდუქტით.
    </p>

    <p>
      <i class="subhead capital purple"><b>1. იჯარის ჩანაცვლება:</b></i>
    </p>

    <p>
      უძრავი ქონების ღირებულებაა 100,000 აშშ დოლარი, ყოველთვიური იჯარა 1,000 აშშ დოლარი.
    </p>

    <p>
      ამ ფართის ლიზინგით დაფინანსების შემთხვევაში: თანამონაწილეობა 20%, დაფინანსება 80%, ნარჩენი ღირებულება (RV) 75%,
      ვადა 120 თვე. ყოველთვიური შენატანი ლიზინგში: 846,33 აშშ დოლარი (მათ შორის დღგ 129 აშშ დოლარი)
    </p>

    <p>
      <i class="subhead capital green"><b>2. სესხის შენატანის შემცირება:</b></i>
    </p>

    <p>
      უძრავი ქონების ღირებულებაა 100,000 აშშ დოლარი, შეძენა დაფინანსებულია ბანკში და სესხის ყოველთვიური გადასახდელია
      1,160 აშშ დოლარო, ვადა 120 თვე.
    </p>

    <p>
      სესხის ლიზინგით რეფინანსირების შემთხვევაში:
    </p>

    <p>
      თანამონაწილეობა 20%, დაფინანსება 80%, ნარჩენი ღირებულება (RV) 75%, ვადა 120 თვე.
    </p>

    <p>
      ყოველთვიური შენატანი ლიზინგში: 846,33 აშშ დოლარი (მათ შორის დღგ 129 აშშ დოლარი)
    </p>

    <img src="../../../../assets/blog/estate-leasing/img4.jpg" alt="" />

    <p>
      <i class="subhead capital light-blue"
        ><b>3. საკუთრებაში არსებული ფართით დაფინანსების მიღება (არადეველოპერი)</b></i
      >
    </p>

    <p>
      თუ იურიდიული ან ფიზიკური პირი ფლობს უძრავ ქონებას, რომლის ღირებულება შეადგენს 100,000 აშშ დოლარს. ნებისმიერი
      საჭიროებისთვის მას შეუძლია ლიზინგის საშუალებით მიიღოს დაფინანსება 80,000 აშშ დოლარის ოდენობით, მაქსიმუმ 120 თვის
      ვადით.
    </p>

    <p>
      <i class="subhead capital dark-blue"><b>4. საკუთრებაში არსებული ფართით დაფინანსების მიღება (დეველოპერი)</b></i>
    </p>

    <p>
      თუ დეველოპერიულ კომპანიას აქვს სარეალიზაციო არასაცხოვრებელი ფართი, მას შეუძლია ფართის რეალიზაციამდე მიიღოს
      დაფინანსება. თუ უძრავი ქონების ღირებულება შეადგენს 100,000 აშშ დოლარს, დეველოპერს აღნიშნულ ფართში შეუძლია ლიზინგის
      საშლებით, მიიღის დაფინანსება 75,000 აშშ დოლარის ოდენობით. დაფარვის გარფიკი კი იქნება მორგებული ამავე ფართის
      რეალიზაციაზე (ძირი თანხის ვადის ბოლოს გადახდის პირობით), ვადა არაუმეტეს 24 თვე.
    </p>

    <p>
      დეტალური ინფორმაციის მისაღებად დაგვიკავშირდი და გაიმარტივე ბიზნესსაქმიანობა, რადგან უძრავი ქონების შეძენა ასეთი
      ხელმისაწვდომი არასოდეს ყოფილა.
    </p>

    <p style="color: #999999">ავტორი: ლალიკო თუმანიშვილი</p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>Here. Now, Commercial Real Estate Leasing for the First Time on the Georgian Market</h1>
    <h6>December 2021</h6>
    <br />
    <p>
      At every stage of communication, we emphasize that leasing, by its nature, is a financing method that simplifies
      business operations, resolves issues related to asset ownership, and helps you achieve the main goal –
      independence, or more specifically, business independence. To demonstrate the above, we have introduced an
      innovative offering to the Georgian market, and despite the fact that almost no country worldwide can surprise you
      with leasing products anymore, we decided to create a unique product that virtually has no analog.
    </p>

    <p>
      Both individuals and legal entities can take advantage of the benefits of commercial real estate leasing. In both
      cases, the main goal is to properly allocate business resources.
    </p>

    <img src="../../../../assets/blog/estate-leasing/img1.jpg" alt="" />

    <p>
      <i class="subhead capital light-blue"><b>For Individuals and Legal Entities</b></i>
    </p>

    <p>
      If you don’t want to waste resources at any stage of your business development and pay rent, this offer is for
      you. In the case of leasing, the monthly payment is competitive, based on the terms specified in the lease
      agreement, but we guarantee ownership of the property. After the leasing agreement ends, the commercial space
      becomes your property, and you can continue developing your business in your own premises.
    </p>

    <p>
      <i class="subhead capital blue"><b>For Developers</b></i>
    </p>

    <p>
      Representatives of development companies are given a unique opportunity to receive financing with the asset owned
      by the company before its sale. Additionally, it is possible to sell leased spaces through leasing, with a payment
      plan tailored to the rent.
    </p>

    <img src="../../../../assets/blog/estate-leasing/img2.jpg" alt="" />

    <p>
      <i class="subhead capital dark-blue"><b>We finance:</b></i>
    </p>

    <p class="list-item">Purchase of commercial, industrial, and office spaces;</p>
    <p class="list-item">Non-residential and auxiliary spaces in completed buildings, as well as parking lots;</p>
    <p class="list-item">
      Leasing of commercial spaces owned by both individuals and legal entities, meaning it is possible to obtain cash
      resources through owned real estate
    </p>

    <p>
      <i class="subhead capital dark-blue"><b>Why?</b></i>
    </p>

    <p class="list-item">Payment schedule tailored to property sales</p>
    <p class="list-item">Flexible and fast service</p>
    <p class="list-item">Leasing term up to 120 months</p>
    <p class="list-item">Zero commission on issuance</p>
    <p class="list-item">
      Financing up to 80% of the asset value, with a payment schedule tailored to your needs, including non-standard
      options
    </p>

    <img src="../../../../assets/blog/estate-leasing/img3.jpg" alt="" />

    <p>
      If you're paying off a loan and wish to reduce your monthly payment, leasing refinancing is the best choice. We
      offer the option of paying the principal at the end of the leasing term.
    </p>
    <p>
      Here are a few practical examples to show how you can benefit from this new product:
    </p>

    <p>
      <i class="subhead capital purple"><b>1. Replacing Rent:</b></i>
    </p>

    <p>
      The value of the property is $100,000, and the monthly rent is $1,000.
    </p>

    <p>
      In the case of leasing for this space: Contribution: 20%, Financing: 80%, Residual Value (RV): 75%, Term: 120
      months, Monthly leasing payment: $846.33 (including VAT of $129)
    </p>

    <p>
      <i class="subhead capital green"><b>2. Reducing Loan Payments:</b></i>
    </p>

    <p>
      The value of the property is $100,000, and the purchase is financed through a bank with a monthly loan payment of
      $1,160, over 120 months.
    </p>

    <p>
      In the case of leasing refinancing:
    </p>

    <p>
      Contribution: 20%, Financing: 80%, Residual Value (RV): 75%, Term: 120 months
    </p>

    <p>
      Monthly leasing payment: $846.33 (including VAT of $129)
    </p>

    <img src="../../../../assets/blog/estate-leasing/img4.jpg" alt="" />

    <p>
      <i class="subhead capital light-blue"><b>Financing with Owned Property (Non-Developer):</b></i>
    </p>

    <p>
      If an individual or legal entity owns real estate valued at $100,000, they can use leasing to receive financing of
      $80,000, with a maximum term of 120 months.
    </p>

    <p>
      <i class="subhead capital dark-blue"><b>4. Financing with Owned Property (Developer):</b></i>
    </p>

    <p>
      If a developer has non-residential space for sale, they can receive financing before the sale of the space. If the
      real estate is valued at $100,000, the developer can obtain financing of $75,000 with leasing. The repayment
      schedule will be tailored to the sale of the space (with payment of the principal at the end of the term), with a
      maximum term of 24 months.
    </p>

    <p>
      For more detailed information, contact us and simplify your business, as real estate acquisition has never been so
      accessible.
    </p>

    <p style="color: #999999">Author: Laliiko Tumanishvili</p>
  </div>
</ng-container>
